import script from "./Tabungan.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabungan.vue?vue&type=script&setup=true&lang=js"

import "./Tabungan.vue?vue&type=style&index=0&id=94fc22be&lang=css"

const __exports__ = script;

export default __exports__